import axios from "axios";

export async function updateServiceStatus(id, service) {
  var apiResponse;
  const data = JSON.stringify([
    {
      outlet_uuid: localStorage.getItem("outlet_uuid"),
      ...service,
    },
  ]);

  const config = {
    method: "put",
    url: `https://api.myfooddo.com/outlet/GetServiceStatus/${id}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const resp = await axios(config);
    apiResponse = resp.data.result;
    return apiResponse;
  } catch (error) {
    console.log(error);
  }
}

export async function getData() {
  var apiResponse;
  const data = JSON.stringify([
    {
      outlet_uuid: localStorage.getItem("outlet_uuid"),
    },
  ]);

  const config = {
    method: "post",
    url: "https://api.myfooddo.com/outlet/GetServiceStatus",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const resp = await axios(config);
    apiResponse = resp.data.result;
    console.log("from api ", apiResponse);
    return apiResponse;
  } catch (error) {
    console.log(error);
  }
}
